import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLang } from '@/context/LangContext';

const LOGO = "https://customer-assets.emergentagent.com/job_lang-assist-2/artifacts/mg2uvgzd_Aurem8%20LOGO%20Beyaz%20%20%283000%20x%203000%20piksel%29.png";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { lang, setLang, t } = useLang();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#C19B76]/10" data-testid="header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" data-testid="logo-link">
            <img src={LOGO} alt="AUREM8" className="h-10 md:h-12 w-auto" />
          </Link>

          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            <Link to="/" className="text-sm font-medium text-[#333] hover:text-[#C19B76] transition-colors">{t.nav.home}</Link>
            <Link to="/about" className="text-sm font-medium text-[#333] hover:text-[#C19B76] transition-colors">{t.nav.about}</Link>
            <Link to="/owa" className="text-sm font-medium text-[#333] hover:text-[#C19B76] transition-colors">{t.nav.owa}</Link>
            <Link to="/contact" className="text-sm font-medium text-[#333] hover:text-[#C19B76] transition-colors">{t.nav.contact}</Link>
            
            <div className="flex items-center gap-1 border border-[#C19B76]/30 rounded-full px-1 py-1" data-testid="lang-switcher">
              {['tr','en','de'].map(l => (
                <button key={l} onClick={() => setLang(l)} className={`text-xs font-medium px-2.5 py-1 rounded-full transition-all ${lang === l ? 'bg-[#C19B76] text-white' : 'text-[#666] hover:text-[#C19B76]'}`} data-testid={`lang-${l}`}>
                  {l.toUpperCase()}
                </button>
              ))}
            </div>

            <a href="https://aurem8.tentary.com/" target="_blank" rel="noopener noreferrer" className="bg-[#C19B76] text-white rounded-full px-6 py-2.5 text-sm font-medium hover:bg-[#A6825B] transition-colors" data-testid="nav-cta">{t.nav.cta}</a>
          </nav>

          <button className="md:hidden text-[#333]" onClick={() => setMobileOpen(!mobileOpen)} data-testid="mobile-menu-button">
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pt-6 pb-4 flex flex-col gap-4">
            <Link to="/" onClick={() => setMobileOpen(false)} className="text-base text-[#333]">{t.nav.home}</Link>
            <Link to="/about" onClick={() => setMobileOpen(false)} className="text-base text-[#333]">{t.nav.about}</Link>
            <Link to="/owa" onClick={() => setMobileOpen(false)} className="text-base text-[#333]">{t.nav.owa}</Link>
            <Link to="/contact" onClick={() => setMobileOpen(false)} className="text-base text-[#333]">{t.nav.contact}</Link>
            <div className="flex gap-2 pt-2">
              {['tr','en','de'].map(l => (
                <button key={l} onClick={() => setLang(l)} className={`text-xs font-medium px-3 py-1.5 rounded-full ${lang === l ? 'bg-[#C19B76] text-white' : 'border border-[#C19B76]/30 text-[#666]'}`}>{l.toUpperCase()}</button>
              ))}
            </div>
            <a href="https://aurem8.tentary.com/" target="_blank" rel="noopener noreferrer" className="bg-[#C19B76] text-white rounded-full px-6 py-3 text-sm font-medium text-center">{t.nav.cta}</a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
